import { Component, Vue } from 'vue-property-decorator';
import MiDataTable, { MiDataTableVisibility } from '@/components/MiDataTable/MiDataTable';
import { Contractor } from '@/models/Contractor';
import CreateContractorDialog from '@/views/Contractors/CreateContractorDialog/CreateContractorDialog.vue';

@Component<Contractors>({
  components: {
    CreateContractorDialog,
  },
})
export default class Contractors extends Vue {
  protected $pageTitle = 'Herstelbedrijven';

  protected contractors: Contractor[] = [];

  protected isCreatingContractor = false;

  protected refreshDatatable(): void {
    this.datatable.refresh();
  }

  protected get tableOptions(): Record<string, unknown> {
    return {
      model: new Contractor().include('address'),
      name: {
        singular: 'Herstelbedrijf',
        plural: 'Herstelbedrijven',
      },
      headers: [
        {
          text: 'Naam',
          value: 'name',
        },
        {
          text: 'Opgericht',
          value: 'registered_since',
          sortable: true,
        },
        {
          text: 'Adres',
          value: 'address',
          sortable: false,
        },
        {
          text: 'Aantal opdrachten',
          value: 'number_of_reports',
          sortable: true,
          align: 'end',
        },
      ],
    };
  }

  protected get datatable(): MiDataTable {
    return this.$refs.contractorDatatable as MiDataTable;
  }

  protected get visibility(): MiDataTableVisibility {
    return {
      filters: false,
      search: true,
    };
  }
}
